class CoachingCardsSection {
  constructor(el) {
    this.el = el;
  }

  init() {
    // Hover and focus are CSS-driven; no runtime behavior needed today.
    // Keeping the class as an init hook for future additions (modal, filter, etc.).
  }

  destroy() {
    // noop
  }
}

function initCoachingCards(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const nodes = scope.matches && scope.matches('[data-section-type="coaching-cards"]')
    ? [scope]
    : Array.from(scope.querySelectorAll('[data-section-type="coaching-cards"]'));

  nodes.forEach((el) => {
    if (el.__coachingCards) return;
    const inst = new CoachingCardsSection(el);
    inst.init();
    el.__coachingCards = inst;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCoachingCards(document));
} else {
  initCoachingCards(document);
}

document.addEventListener('shopify:section:load', (e) => {
  if (!e.target) return;
  initCoachingCards(e.target);
});

document.addEventListener('shopify:section:unload', (e) => {
  if (!e.target) return;
  const nodes = e.target.matches && e.target.matches('[data-section-type="coaching-cards"]')
    ? [e.target]
    : Array.from(e.target.querySelectorAll('[data-section-type="coaching-cards"]'));
  nodes.forEach((el) => {
    if (el.__coachingCards && typeof el.__coachingCards.destroy === 'function') {
      el.__coachingCards.destroy();
    }
    el.__coachingCards = null;
  });
});
